import type { z } from 'zod/v4-mini';
import type { DataBus, DataBusPath } from '@ms-cloudpack/data-bus';

/**
 * Waits for data to be published on a specific bus path, with a timeout.
 */
export async function waitForBusData<T>(params: {
  /** Data bus to listen on */
  bus: DataBus;
  /** Path to subscribe to */
  source: DataBusPath<z.ZodMiniType>;
  /** Timeout in milliseconds */
  timeoutMs?: number;
}): Promise<T> {
  const { bus, source, timeoutMs = 120000 } = params;
  return new Promise<T>((res, rej) => {
    // Set up subscription to the bus path
    const unsubscribe: () => void = bus.subscribe(source, (value: unknown) => {
      clearTimeout(timeoutId);
      res(value as T);
      unsubscribe();
    });

    // Set up timeout
    const timeoutId = setTimeout(() => {
      unsubscribe();
      rej(new Error(`Timeout waiting for bus data on path ${source.path.join('.')}`));
    }, timeoutMs);
  });
}
